import isNil from "lodash-es/isNil";
import wretch, { type WretchError } from "wretch";
import { abortAddon, formDataAddon, queryStringAddon } from "wretch/addons";
import { generateTraceparent, isTraceparentReady } from "./utils/httpUtils";

export const ACCEPT_FALLBACK_HEADER = { "X-Accept-Fallback-Cache": "true" } as const;

type ApiClientRequestSettings = {
   headers?: Record<string, string>;
   credentials?: RequestCredentials;
};

export const apiClient = (
   url: string,
   token?: string | null,
   controller?: AbortController,
   requestSettings: ApiClientRequestSettings = {}
) => {
   let client = wretch(url)
      .addon(queryStringAddon)
      .addon(formDataAddon)
      .addon(abortAddon())
      .headers({ ...createHeaders(url), ...requestSettings.headers });

   if (controller) {
      client = client.signal(controller);
   }
   if (!isNil(requestSettings.credentials)) {
      client = client.options({ credentials: requestSettings.credentials });
   }
   if (!isNil(token)) {
      client = client.auth(`Bearer ${token}`);
   }

   return client;
};

export const ensureWretchError = (error: unknown): WretchError | null => {
   if ((error as WretchError).response) {
      return error as WretchError;
   }
   return null;
};

const createHeaders = (url: string): Record<string, string> => {
   const headers: Record<string, string> = {
      Accept: "application/json"
   };

   if (isTraceparentReady(url)) {
      headers.traceparent = generateTraceparent();
   }

   return headers;
};
